module.exports = __webpack_public_path__ + "static/media/img_english.7936d570.png";